import { Project, SimpleProject } from '../../models/models';
import { clearNodeProjectSelected, clearProjectSelected, getMyProjectsFailed, getMyProjectsSuccess, getProjectFailed, getProjectSuccess } from './project.action';

export type ProjectState = {
    readonly projectSelected: Project | null;
    readonly nodeProjectSelected: Project | null;
    readonly myProjects: SimpleProject[];
};

const INITIAL_STATE: ProjectState = {
    projectSelected: null,
    nodeProjectSelected: null,
    myProjects: [],
};

export const projectReducer = (state = INITIAL_STATE, action: any) => {

    if (getProjectSuccess.match(action)) {
        const { nodeId, projectSelected } = action.payload;
        const newState = {
            ...state,
            projectSelected: nodeId ? state.projectSelected : projectSelected,
            nodeProjectSelected: nodeId ? projectSelected : state.nodeProjectSelected,
        };
        return newState;
    }

    if (getMyProjectsSuccess.match(action)) {
        const { myProjects } = action.payload;
        return { ...state, myProjects };
    }

    if (getProjectFailed.match(action)) {
        return { ...state, projectSelected: null, nodeProjectSelected: null };
    }

    if (clearProjectSelected.match(action)) {
        return { ...state, projectSelected: null };
    }

    if (clearNodeProjectSelected.match(action)) {
        return { ...state, nodeProjectSelected: null };
    }

    if (getMyProjectsFailed.match(action)) {
        return { ...state, myProjects: [] };
    }

    return state;
};